/**
 * Cold-boot screen — TASK 7.1.
 *
 * The mock's `booting` state (mock/SteamyMusic.dc.html L31-36), extracted
 * verbatim: a full-viewport centred column holding the Rubik Spray Paint
 * wordmark and the 34px teal ring spinner.
 *
 *   <div style="min-height:100vh;display:flex;align-items:center;
 *               justify-content:center;flex-direction:column;gap:18px">
 *     <div style="font-family:'Rubik Spray Paint';font-size:44px;color:#FFD337;
 *                 text-shadow:4px 4px 0 #FF3E8E">SteamyMusic</div>
 *     <div style="width:34px;height:34px;border:4px solid #35E0C8;
 *                 border-top-color:transparent;border-radius:50%;
 *                 animation:smSpin 1s linear infinite"
 *          role="status" aria-label="Loading"></div>
 *   </div>
 *
 * -> `.sm-screen-boot` + `.sm-wordmark.sm-wordmark--splash` +
 *    `Spinner({ size: 'boot' })`.
 *
 * This is what `src/main.ts` paints on first frame. TASK 7.2 replaces the
 * body of the shell around it; the boot screen itself stays as the pre-hydration
 * paint.
 *
 * @module
 */

import { append, el } from './components/primitives/dom.js';
import { Spinner } from './components/primitives/Skeleton.js';

/**
 * Builds (does not mount) the boot screen.
 *
 * @returns {HTMLElement}
 */
export function BootScreen() {
  return append(
    el('div', { className: 'sm-screen-boot' }),
    el('div', { className: 'sm-wordmark sm-wordmark--splash', text: 'SteamyMusic' }),
    Spinner({ size: 'boot', label: 'Loading' }),
  );
}

/**
 * Renders the boot screen into `root`, replacing whatever is there.
 *
 * @param {HTMLElement|null} root the `#app` container from index.html
 * @returns {HTMLElement} the mounted boot screen
 */
export function mountBootScreen(root) {
  if (root === null) {
    throw new Error('mountBootScreen: no mount point — index.html must contain <div id="app">');
  }
  const screen = BootScreen();
  root.replaceChildren(screen);
  return screen;
}
